import { useState } from "react";
import { toast } from "sonner";
import { api } from "../../lib/api";
import { useAuth, apiError } from "../../lib/auth";
import { NeonButton } from "../common";

export const ResolutionActions = ({ d, letter, onDone }) => {
  const { isOwner } = useAuth();
  const [msg, setMsg] = useState(letter || "");
  const [busy, setBusy] = useState("");
  if (d.processor !== "whop_reso" || d.status !== "needs_response" || !isOwner) return null;
  const allowed = d.available_actions?.length ? d.available_actions : ["accept", "deny", "request_info"];
  const go = async (a) => {
    if (!window.confirm(`Send "${a.replace("_", " ")}" to Whop for this case?`)) return;
    setBusy(a);
    try { await api.post(`/resolution/${d.id}/${a}`, { message: msg }); toast.success("Sent to Whop"); onDone?.(); }
    catch (e) { toast.error(apiError(e)); } finally { setBusy(""); }
  };
  return (
    <div className="panel p-4 mt-4" data-testid="resolution-actions">
      <p className="label-xs">Respond in Whop's Resolution Center</p>
      <textarea rows={5} value={msg} onChange={(e) => setMsg(e.target.value)} className="mt-2 w-full bg-field border border-fieldline px-3 py-2 text-sm focus:outline-none focus:border-brand" data-testid="resolution-message" />
      <div className="flex flex-wrap gap-2 mt-2">
        {allowed.includes("deny") && <NeonButton onClick={() => go("deny")} disabled={!!busy || msg.length < 5} data-testid="resolution-deny-btn">Deny with evidence</NeonButton>}
        {allowed.includes("request_info") && <NeonButton variant="ghost" onClick={() => go("request_info")} disabled={!!busy || msg.length < 5} data-testid="resolution-info-btn">Request info</NeonButton>}
        {allowed.includes("accept") && <NeonButton variant="danger" onClick={() => go("accept")} disabled={!!busy || msg.length < 5} data-testid="resolution-accept-btn">Accept & refund</NeonButton>}
      </div>
    </div>
  );
};
